/**
 * Created by Carsten Bühler
 * User: c.buehler on 01.02.2019
 * Copyright: xdot GmbH 2019
 */

import React from 'external/react';
import PropTypes from 'external/prop-types';
import { Table } from 'external/react-bootstrap';
import { ItemDescription } from 'plugin/base-portlet';

import { AppContext } from 'plugin/liferay-widgets-react-web';

import { getStateStore } from '../stores/StoreFactory';
import StateValueLabel from './StateValueLabel';

const StateStore = getStateStore(AppContext);

class StateDetailsList extends React.Component {
    render() {
        const { status } = this.props;
        const states = StateStore.getStatesByClassNamePropName(status.className, status.propName);

        return (
            <Table striped bordered>
                <thead>
                <tr>
                    <th>
                        Titel
                    </th>
                    <th>
                        Visualisierung
                    </th>
                    <th>
                        Gesamtzustand
                    </th>
                    <th>
                        Beschreibung
                    </th>
                </tr>
                </thead>
                <tbody>
                {
                    states.filter(s => s.active).sort((s1, s2) => s1.weight === s2.weight ? 0 : (s1.weight > s2.weight ? 1 : -1)).map(s => (
                        <tr key={'state_' + s.id}>
                            <td>
                                {s.stateTitle}
                            </td>
                            <td>
                                <StateValueLabel item={{ state: s }}/>
                            </td>
                            <td>
                                <span
                                    className={'overall-state-box state-' + (s.overallState || s.state.overallState)}/>
                            </td>
                            <td>
                                <ItemDescription item={s}/>
                            </td>
                        </tr>))
                }
                </tbody>
            </Table>
        );
    }
}

StateDetailsList.propTypes = {
    status: PropTypes.object.isRequired
};

export default StateDetailsList;



// WEBPACK FOOTER //
// ./js/components/StateDetailsList.jsx